<template>
  <div>
    <div ref="editor" style="text-align:left" :disable="disabled">
    </div>
  </div>
</template>

<script>
  import Editor from 'wangeditor'
  import {mapGetters} from "vuex"
  var editor;
  export default {
    name: 'SjEditor',
    props:{
      value: {
        type: String,
        default: ''
      },
      // 是否禁用
      disabled: {
        type: Boolean,
        default: false
      },
      // 是否开启粘贴样式的过滤
      pasteFilterStyle: {
        type: Boolean,
        default: false
      },

      // 是否忽略粘贴内容中的图片
      pasteIgnoreImg : {
        type: Boolean,
        default: false
      },

      // 图片大小
      uploadImgMaxSize:{
        type: Number,
        default: 5 * 1024 * 1024
      },

      // 一次做多上传图片数量
      uploadImgMaxLength:{
        type: Number,
        default: 1
      },

      // 设置菜单项
      menus: {
        type: Array,
        default: function(){
          return [
            /*'undo',  // 撤销
            'redo',  // 重复,*/
            'head',  // 标题
            'bold',  // 粗体
            'fontSize',  // 字号
            'fontName',  // 字体
            'italic',  // 斜体
            'underline',  // 下划线
            'strikeThrough',  // 删除线
            'foreColor',  // 文字颜色
            'backColor',  // 背景颜色
            'link',  // 插入链接
            'list',  // 列表
            'lineHeight', //行高
            'justify',  // 对齐方式
            'quote',  // 引用
            'emoticon',  // 表情
            'image',  // 插入图片
            'table',  // 表格
            // 'video',  // 插入视频
            // 'code'  // 插入代码

          ]
        }
      },
      // 设置优先级
      zIndex:{
        type: Number,
        default: 10000
      },
      lang: {
        type: Object,
        default: function(){
          return {
            '设置标题': 'title',
            '正文': 'p',
            '链接文字': 'link text',
            '链接': 'link',
            '上传图片': 'upload image',
            '上传': 'upload',
            '创建': 'init'
            // 还可自定添加更多
          }
        }
      },
      // 是否默认字体和间距
      defaultFont: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        text: ''
      }
    },
    computed:{
      ...mapGetters(["token"])
    },
    methods: {

      initEditor(){
        // 声明容器
        editor = new Editor(this.$refs.editor)
        // 设置菜单项
        editor.config.menus = this.menus;
        // 限制文件大小
        editor.config.uploadImgMaxSize = this.uploadImgMaxSize;
        // 限制一次最多上传 5 张图片
        editor.config.uploadImgMaxLength = this.uploadImgMaxLength;
        // 是否开启粘贴样式的过滤
        editor.config.pasteFilterStyle = this.pasteFilterStyle;
        // 添加图片时不显示 链接 选项
        editor.config.showLinkImg = false;
        // 是否忽略粘贴内容中的图片
        editor.config.pasteIgnoreImg = this.pasteIgnoreImg;
        // 内容发生变化时
        editor.config.onchange = this.changeContent;



        //配置字体
        editor.config.fontNames = [
               '黑体',
              '仿宋',
              '楷体',
              '标楷体',
              '华文仿宋',
              '华文楷体',
               '宋体',
              '微软雅黑',
              '仿宋_GB2312'
        ]
        // 文件上传的方法
        editor.config.customUploadImg = this.uploadImage;
        //设置字号大小
        editor.config.fontSizes = {
             'x-small': { name: '一号', value: '1', },
              'small': { name: '二号', value: '2', },
              'normal': { name: '三号', value: '3', },
              'large': { name: '小三号', value: '4', },
              'x-large': { name: '四号', value: '5', },
              'xx-large': { name: '五号', value: '6', },
        }
        //设置行高
        editor.config.lineHeights = ['1', '1.15','1.5', '1.6', '2', '2.5', '3'];

        editor.create();

        editor.$textElem.attr('contenteditable', !this.disabled)

        if(this.defaultFont) {
          editor.$textElem.elems[0].style.fontFamily = '仿宋';
          editor.$textElem.elems[0].style.lineHeight = '1.5';
        } else {
          editor.$textElem.elems[0].style.fontFamily = '';
          editor.$textElem.elems[0].style.lineHeight = '';
        }
        // 回显
        editor.txt.html(this.value);
      },

      changeContent(html){
        this.$emit('input', html);
      },

      beforeUpload(){

      },

      uploadImage(files, insert) {
        let data = new FormData()
        data.append("file",files[0])
        let xhr = new XMLHttpRequest()
        xhr.open("POST","/share-foreign/commannex/uploadAnnex")
        xhr.setRequestHeader("Authorization",this.token)
        xhr.onreadystatechange = e=>{
          if(xhr.readyState==4){
            let {response} = xhr
            let path = JSON.parse(response).data
            insert("/share-foreign/commannex/viewAnnex?path="+path+"&token="+this.token)
          }
        }
        xhr.send(data)
      },

      // 设置内容
      setContent(html){
        editor.txt.html(html);
      },

      // 清空内容
      clearContent(html){
        editor.txt.clear()
      }

    },
    mounted() {
      this.initEditor();
    },
    watch:{

    }
  }
</script>

<style scoped>

</style>
